/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import { GET_STATIC_EMPLOYEES_GQL, GET_STATIC_EMPLOYEE_GQL } from '@/graphql/static-queries.gql';

const initEmployee = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  role: { id: '3', title: 'Employee' },
  teams: [],
  categories: [],
  permissions: [],
};

export default {
  namespaced: true,

  state: {
    // = data
    staticEmployee: Object.assign({}, initEmployee),
    staticEmployees: [],
  },

  mutations: {
    SET_STATIC_EMPLOYEE(state, payload) {
      state.staticEmployee = payload;
    },
    SET_STATIC_EMPLOYEES(state, payload) {
      state.staticEmployees = payload;
    },
  },

  actions: {
    getStaticEmployees({ commit }) {
      commit('shared/SET_LOADING', true, { root: true });

      apolloClient
        .query({ query: GET_STATIC_EMPLOYEES_GQL })
        .then(({ data }) => {
          commit('SET_STATIC_EMPLOYEES', data.staticEmployees);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    getStaticEmployee({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, { root: true });

      apolloClient
        .query({
          query: GET_STATIC_EMPLOYEE_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_STATIC_EMPLOYEE', data.staticEmployee);
          commit('shared/SET_LOADING_CHILD', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING_CHILD', false, { root: true });
        });
    },

    resetStaticEmployee({ commit }) {
      commit('SET_STATIC_EMPLOYEE', Object.assign({}, initEmployee));
    },
  },

  getters: {
    // = computed properties
    staticEmployee: state => state.staticEmployee,
    staticEmployees: state => state.staticEmployees,
  },
};
